class BaseOutputField {
    constructor(calculator, selector, name, params) {
        this.calculator = calculator;
        this.container = $(selector);
        this.name = name;
        this.params = params;
        this.setup();
    }

    setup() {}

    get(paramName, defaultValue) {
        if (this.params !== undefined && this.params[paramName] !== undefined)
            return this.params[paramName];
        return defaultValue;
    }

    get renderMethod() {
        if (this.get('html') !== undefined) {
            return 'html';
        }
        return 'text';
    }

    get type() {
        return this.get('type', 'text');
    }

    get value() {
        return this.calculator[this.name];
    }

    compose() {
        const val = this.value;
        if (this.params === undefined && val !== undefined) {
            if (val.hasOwnProperty('text'))
                return val.text;
            return val;
        }
    }

    compose_() {
        const renderFunc = this.get('render');
        if (renderFunc === undefined) {
            return this.compose();
        }
        return renderFunc(this.value);
    }

    render() {
        this.container[this.renderMethod](this.compose_());
    }

    renderExport(exportObject) {
        exportObject[this.name + '_' + this.type] = this.compose_();
    }
}

class RenderRequiredOutputField extends BaseOutputField {
    setup() {
        const renderFunc = this.get('render');
        if (renderFunc == undefined) {
            console.error(`You must write render method for [${this.type}] type of output field.`);
        }
        this.renderFunc = renderFunc;
    }

    compose() {
        return this.renderFunc(this.value);
    }
}

class HtmlOutputField extends BaseOutputField {
    get renderMethod() { return 'html'; }
}

class TextField extends HtmlOutputField {
    compose() { return this.value; }
}

class LocaleNumOutputField extends BaseOutputField {
    compose() {
        const options = {
            minPrecision: this.get('minPrecision'),
            maxPrecision: this.get('maxPrecision')
        };
        return tools.getLocaleNumber(this.value, options);
    }
}

class LocaleSumOutputField extends BaseOutputField {
    compose() { return tools.getLocaleSum(this.value); }
}

class MoneyRubleOutputField extends HtmlOutputField {
    compose() { return tools.getLocaleSumInRubbles(this.value); }
}

class MoneyTextOutputField extends BaseOutputField {
    compose() { return tools.verboseNumber(this.value); }
}

class MoneyRoundedRubleField extends HtmlOutputField {
    compose() { return tools.getRoundedNumberInRubbles(this.value); }
}

class MoneyRoundedRubleOutputField extends HtmlOutputField {
    compose() { return tools.getRoundedNumberInRubbles(this.value); }
}

class PeriodOutputField extends BaseOutputField {
    compose() {
        const from_ = this.value.dateFrom.toLocaleFormat();
        const to_ = this.value.dateTo.toLocaleFormat();
        switch (this.get('kind', 'with-duration')) {
            case 'with-duration':
                return `с ${from_} по ${to_} (${this.value.duration.inDays} дн.)`;
            case 'with-full-duration':
                return `с ${from_} по ${to_} (${tools.verboseCountingValue(this.value.duration.inDays, [['день', 'дня', 'дней']])})`;
        }
    }
}

class DateOutputField extends BaseOutputField {
    compose() { return this.value.toLocaleFormat(); }
}

class DayOutputField extends BaseOutputField {
    compose() { 
        return tools.verboseCountingValue(this.value, [["день", "дня", "дней"]]);}
}

class PercentOutputField extends HtmlOutputField {
    compose() {
        const options = {
            minPrecision: this.get('minPrecision'),
            maxPrecision: this.get('maxPrecision')
        };

        return tools.getLocaleNumber(this.value, options) + "%";
    }
}

class NoteOutputField extends RenderRequiredOutputField {
    render() {
        const result = this.compose_();
        this.container.removeClass('active only-print');
        if (result === 'print' || result === true) {
            this.container.addClass('active');
            if (result === 'print') {
                this.container.addClass('only-print');
            }
        }
    }

    renderExport(exportObject) {
        const result = this.compose_();
        if (result === 'print' || result === true) {
            exportObject.notes.push(tools.convertElemToTextWithLinksForExport(this.container));
        }
    }
}

/**
 *  works with only direct children elements
 *  Takes optional params: 
 *      - parseLink : true if convertElemToTextWithLinksForExport is needed
 *      - selector  : selector for additional logic
 */
class ExportVisibleOutputField extends BaseOutputField {
    renderExport(exportObject) {
        const selector = this.get('selector', '> *');
        const htmlObject = this.container.find(`${selector}:visible`).toArray().filter(x=>$(x).text())[0];

        exportObject[this.name] = this.get("parseLink") && htmlObject 
        ? tools.convertElemToTextWithLinksForExport(htmlObject) 
        : $(htmlObject).text();
    }
}

/**
 *  Takes optional params: 
 *      - duration : object with slideUp and slideDown time or true to use default time
 */
class ToggleOutputField extends RenderRequiredOutputField {
    render() {
        const slideUpTime = this.get('duration', {slideUp : undefined}).slideUp;
        const slideDownTime = this.get('duration', {slideDown : undefined}).slideDown;

        const show = () => this.get('duration') ? this.container.slideDown(slideUpTime || 400) : this.container.show();
        const hide = () => this.get('duration') ? this.container.slideUp(slideDownTime || 400) : this.container.hide();

        if (this.compose_())
            show();
        else
            hide();
    }
}

class ConditionalBlockOutputField extends RenderRequiredOutputField {
    setup() {
        super.setup();
        const alternativeBlockSelector = this.get('alternativeBlock', '');
        if (alternativeBlockSelector === '') {
            console.warn("It's bad way to use `conditionalBlock` with empty alternativeBlock param. Try to use `toggle` instead.")
        }
        this.alternativeBlock = $(alternativeBlockSelector);
    }

    render() {
        if (this.compose_()) {
            this.container.show();
            this.alternativeBlock.hide();
        }
        else {
            this.container.hide();
            this.alternativeBlock.show();
        }
    }
}

class ShareOutputField extends HtmlOutputField {
    compose() {
        return this.value.text.replace('%', '&nbsp;%');
    }
}

class MoneyLocalRoundedOutField extends HtmlOutputField {
    compose() {
        return tools.getLocaleSumInRubbles(tools.getRoundedNumber(this.value))
    }
}

function createOutputField(calculator, selector, name, params) {
    let params_ = params || {};
    let class_ = undefined;
    switch (params_.type) {
        case 'localeNumber': class_ = LocaleNumOutputField; break;
        case 'localeSum': class_ = LocaleSumOutputField; break;
        case 'moneyRuble': class_ = MoneyRubleOutputField; break;
        case 'moneyRoundedRuble': class_ = MoneyRoundedRubleOutputField; break;
        case 'moneyText': class_ = MoneyTextOutputField; break;
        case 'moneyRoundedRuble': class_ = MoneyRoundedRubleField; break;
        case 'moneyLocalRoundedRuble': class_ = MoneyLocalRoundedOutField; break
        case 'period': class_ = PeriodOutputField; break;
        case 'date': class_ = DateOutputField; break;
        case 'percent': class_ = PercentOutputField; break;
        case 'note': class_ = NoteOutputField; break;
        case 'toggle': class_ = ToggleOutputField; break;
        case 'conditionalBlock': class_ = ConditionalBlockOutputField; break;
        case 'day': class_ = DayOutputField; break;
        case 'share': class_ = ShareOutputField; break;
        case 'text': class_ = TextField; break;
        case 'exportVisible' : class_ = ExportVisibleOutputField; break
        default: class_ = BaseOutputField; break;
    }

    return new class_(calculator, selector, name, params);
}

export { createOutputField };